import VideoAndImageComponent from './VideoAndImageComponent';

export default VideoAndImageComponent;
